import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=65f8364a&"
import script from "./SuppliersList.vue?vue&type=script&lang=js&"
export * from "./SuppliersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports